import { lazy } from 'react';

export const ClientAddFormLazy = lazy(() => import('./client_add_form'));
